/* eslint-disable no-undef */
import { nextTick } from '../utils/utils';

const noop = () => {};

const fadeOutBackgroundVideo = () => {
  ScrollTrigger.create({
    trigger: '.js-top',
    start: `top top`,
    end: 'max+=100%',
    toggleClass: {
      targets: '.js-movie',
      className: '-fade'
    }
  });
};

const slideInHeroContent = () => {
  gsap.set('.js-hero-inner', { opacity: 1 });

  const timeline = gsap.timeline();

  timeline.from('.js-hero-text', {
    duration: 0.5,
    // y: '100%',
    stagger: 0.3,
    ease: Power2.easeOut
  });
};

const fadeOutHeroContent = () => {
  gsap.to('.js-hero-inner', {
    scrollTrigger: {
      trigger: '.js-top',
      start: 'top top',
      endTrigger: '.js-statement',
      end: 'top center',
      scrub: 1
    },
    opacity: 0
  });
};

const fadeInOutFloatingButton = () => {
  ScrollTrigger.create({
    trigger: '.js-statement',
    start: 'top center',
    endTrigger: '.js-info',
    end: 'top bottom+=100px',
    toggleClass: {
      targets: '.js-floating-button',
      className: '-show'
    }
  });
};

const toggleBackgroundVideo = () => {
  ScrollTrigger.create({
    trigger: '.js-message',
    start: 'top+=30% top',
    end: 'max+=100%',
    toggleClass: {
      targets: '.js-movie',
      className: '-hidden'
    }
  });
};

const slideInTitle = () => {
  const title1List = document.querySelectorAll('.js-title-text1');

  title1List.forEach((title1, index) => {
    const timeline1 = gsap.timeline({
      scrollTrigger: {
        trigger: title1,
        start: 'top-=100% bottom-=30%',
        end: 'max'
      }
    });

    timeline1.from(title1, {
      duration: 0.5,
      y: '100%',
      ease: Power2.easeOut
    });
  });
};

const scaleInMessageSection = () => {
  gsap.set('.js-message-inner', { scale: 1.12 });

  gsap.to('.js-message-inner', {
    scrollTrigger: {
      trigger: '.js-message',
      start: 'top bottom-=30%',
      end: 'max'
    },
    duration: 0.8,
    scale: 1,
    ease: Power3.easeOut
  });
};

const slideInDomainItem = () => {
  document.querySelectorAll('.js-domain-item').forEach((target) => {
    ScrollTrigger.create({
      trigger: target,
      start: 'top bottom-=20%',
      end: 'max',
      toggleClass: {
        targets: target,
        className: '-active'
      },
      once: true
    });
  });
};

const crossFadeBackgroundImage = () => {
  const interval = 4.4;
  const timeline = gsap.timeline({
    repeat: -1,
    repeatDelay: interval,
    scrollTrigger: {
      trigger: '.js-change',
      start: 'top top+=20%',
      end: 'max'
    }
  });

  timeline
    .to('.js-fade-background2', {
      opacity: 1,
      duration: 1.2,
      ease: Power2.easeOut
    })
    .to('.js-fade-background1', { opacity: 0, zIndex: -1, duration: 0 })
    .to(
      '.js-fade-background3',
      {
        opacity: 1,
        duration: 1.2,
        ease: Power2.easeOut
      },
      `+=${interval}`
    )
    .to('.js-fade-background2', { opacity: 0, duration: 0 })
    .to(
      '.js-fade-background1',
      {
        opacity: 1,
        duration: 1.2,
        ease: Power2.easeOut
      },
      `+=${interval}`
    )
    .to('.js-fade-background3', { opacity: 0, duration: 0 })
    .to('.js-fade-background1', { zIndex: -4, duration: 0 });
};

const moveParallelWideText = () => {
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: '.js-wide-text1',
      start: 'top bottom-=10%',
      endTrigger: '.js-wide-text2',
      end: 'bottom top',
      scrub: 1
    }
  });

  timeline
    .to('.js-wide-text1', {
      duration: 0.1,
      x: '60%',
      ease: 'power0'
    })
    .to(
      '.js-wide-text2',
      {
        duration: 0.1,
        x: '-60%',
        ease: 'power0'
      },
      '<'
    );
};

const fadeInTextByCharacter = async () => {
  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: '.js-text-group',
      start: 'top bottom-=40%',
      end: 'max'
    }
  });

  // eslint-disable-next-line no-undef
  const splitText = new SplitText('.js-text-group', { type: 'words,chars' });
  const { chars } = splitText;

  gsap.set(chars, {
    y: '60%',
    opacity: 0,
    willChange: 'transform, opacity'
  });

  await nextTick();

  timeline
    .to(chars, {
      duration: 1.2,
      opacity: 1,
      y: '0',
      stagger: 0.008,
      ease: 'quint.out'
    })
    .from(
      '.js-chars-svg',
      {
        duration: 2.2,
        opacity: 0,
        y: '130%',
        ease: 'expo.out'
      },
      '-=.5'
    )
    .set(chars, {
      clearProps: 'will-change'
    });
};

const moveLoopBackgroundImage = () => {
  const loopBackground = document.querySelector('.js-loop-background');
  const loopItem = (window.innerWidth, loopBackground.children[0]);
  loopBackground.appendChild(loopItem.cloneNode(true));

  const timeline = gsap.timeline({ repeat: -1 });

  timeline
    .to(loopBackground, {
      xPercent: -100,
      duration: 80,
      ease: Power0.easeNone
    })
    .to(loopBackground, { x: 0, duration: 0, ease: Power0.easeNone });
};

const traceLocalNav = () => {
  if (window.matchMedia('(min-width:769px)').matches) {
    const navList = document.querySelectorAll('.js-nav');

    const reverseColor = (currentSection, nextSection) => {
      navList.forEach((nav) => {
        const navPositionY =
          nav.getBoundingClientRect().top +
          nav.getBoundingClientRect().height / 2;

        ScrollTrigger.create({
          trigger: currentSection,
          start: `top top+=${navPositionY}px`,
          endTrigger: nextSection,
          end: `top top+=${navPositionY}px`,
          toggleClass: {
            targets: nav,
            className: '-reverse'
          }
        });
      });
    };

    reverseColor('.js-top', '.js-message');
    reverseColor('.js-black-background', '.js-change-lower');
  }

  ScrollTrigger.create({
    trigger: '.js-statement',
    start: 'top-=300px top',
    endTrigger: '.js-info',
    end: 'top bottom-=30%',
    toggleClass: {
      targets: '.js-nav-list',
      className: '-active'
    }
  });

  const animateLocalNav = (
    currentSection,
    nextSection,
    navNumber,
    {
      onLeave = () => {
        gsap.to(`.js-nav-lead${navNumber}`, {
          duration: 0.65,
          ease: 'expo.out',
          scaleY: 0,
          transformOrigin: 'bottom center'
        });
      }
    }
  ) => {
    ScrollTrigger.create({
      trigger: currentSection,
      start: 'top-=300px top',
      endTrigger: nextSection,
      end: 'top-=300px top',
      toggleClass: {
        targets: `.js-local-nav${navNumber}`,
        className: '-active'
      }
    });

    gsap.from(`.js-nav-lead${navNumber}`, {
      duration: 0.2,
      ease: 'power0',
      scaleY: 0,
      transformOrigin: 'top center',
      scrollTrigger: {
        trigger: currentSection,
        start: 'top-=300px top',
        endTrigger: nextSection,
        end: 'top-=300px top',
        scrub: true,
        onLeave
      }
    });
  };

  animateLocalNav('.js-statement', '.js-message', 1, {});
  animateLocalNav('.js-message', '.js-vision', 2, {});
  animateLocalNav('.js-vision', '.js-domains', 3, {});
  animateLocalNav('.js-domains', '.js-change', 4, {});
  animateLocalNav('.js-change', '.js-action', 5, {});
  animateLocalNav('.js-action', '.js-info', 6, {
    onLeave: noop
  });
};

export const animateAll = () => {
  fadeOutBackgroundVideo();
  slideInHeroContent();
  fadeOutHeroContent();
  fadeInOutFloatingButton();
  toggleBackgroundVideo();
  slideInTitle();
  scaleInMessageSection();
  slideInDomainItem();
  crossFadeBackgroundImage();
  moveParallelWideText();
  fadeInTextByCharacter();
  moveLoopBackgroundImage();
  traceLocalNav();
};

// animation
